/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'ai-mate.agent-details.created-by': 'Created by',
  'ai-mate.agent-details.description': 'Description',
  'ai-mate.agent-details.instruction': 'Instruction',
  'ai-mate.agent-details.knowledge': 'Knowledge',
  'ai-mate.agent-details.name': 'Name',
  'ai-mate.agent-form.agents-external-files.dropzone-area-text': 'Drop files to attach or <link>browse</link>',
  'ai-mate.agent-form.agents-external-files.file-viewer.delete-action-label': 'Delete',
  'ai-mate.agent-form.cancel-button': 'Close',
  'ai-mate.agent-form.custom-prompt-helper-message': 'Customize the prompt for this agent',
  'ai-mate.agent-form.custom-prompt-input': 'Custom Prompt',
  'ai-mate.agent-form.description-input': 'Description',
  'ai-mate.agent-form.error-agent-in-use':
    'This agent is currently being used by someone and cannot be made private at this time. Please try again later.',
  'ai-mate.agent-form.error-agent-name-exists': 'Agent name already exists. Please choose another name.',
  'ai-mate.agent-form.error-incorrect-owner': 'You are not the owner of this agent and cannot make changes to it.',
  'ai-mate.agent-form.form-error': 'Could not save changes',
  'ai-mate.agent-form.name-input': 'Name',
  'ai-mate.agent-form.name-input-exists-error-message': 'A agent with this name already exists',
  'ai-mate.agent-form.publish-agent': 'Publish',
  'ai-mate.agent-form.publish-setting-button': 'More publish options',
  'ai-mate.agent-form.publish-setting-private': 'Only me',
  'ai-mate.agent-form.publish-setting-public': 'Anyone in this site',
  'ai-mate.agent-form.required-label': 'Required fields are marked with an asterisk',
  'ai-mate.agent-form.spaces-select': 'Spaces',
  'ai-mate.agent-form.spaces-select-helper-message':
    'Select spaces for the agent to answer questions with better context',
  'ai-mate.agent-form.spaces-select-placeholder': 'Search for spaces...',
  'ai-mate.agent-form.title-create': 'Add a new agent',
  'ai-mate.agent-form.title-edit': 'Edit agent "{agentName}"',
  'ai-mate.agent-list.close-button': 'Close',
  'ai-mate.agent-list.create-agent-button': 'Create new agent',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Are you sure you want to delete this agent? This action cannot be undone.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Delete "{agentName}"?',
  'ai-mate.agent-list.delete-agent-error': 'Could not delete agent',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': 'Agent is currently in use. Try again later.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'That agent could not be found.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'You cannot delete agents you have not created yourself. Please contact the agent owner.',
  'ai-mate.agent-list.delete-agent-success': 'Agent has been deleted!',
  'ai-mate.agent-list.public-agents-title': 'Public agents',
  'ai-mate.agent-list.show-hide-label': 'Show/hide {agentName}',
  'ai-mate.agent-list.system-agents-title': 'Atlassian agents',
  'ai-mate.agent-list.title': 'Discover and manage agents',
  'ai-mate.agent-message.error': 'Reload chat',
  'ai-mate.agent-message.general-error': "Oops. We've got an error.",
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Cancel',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Delete',
  'ai-mate.agent-picker.dropdown-item.agents-dropdown-group-title': 'Agents that can help',
  'ai-mate.agent-picker.dropdown-item.chat-history': 'Chat history',
  'ai-mate.agent-picker.dropdown-item.create': 'Create an Agent',
  'ai-mate.agent-picker.dropdown-item.debug-mode': 'Debug mode',
  'ai-mate.agent-picker.dropdown-item.list': 'Browse Agents',
  'ai-mate.agent-picker.dropdown-item.submit-feedback': 'Submit feedback',
  'ai-mate.agent-picker.dropdown-trigger-label': 'Select agent',
  'ai-mate.agent-picker.input-max-length-error-message':
    "{fieldName} can't exceed {maxLength, plural, one {# character} other {# characters}}",
  'ai-mate.agent-popup.create-agent-button': 'Create a new agent',
  'ai-mate.agent-popup.manage-agents-button': 'Manage agents',
  'ai-mate.agent-popup.modal-title': 'Agent configuration',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.cameo-dropdown.trigger-label': 'Select agent',
  'ai-mate.chat-history.empty-state.brand-name': 'Chat',
  'ai-mate.chat-history.empty-state.message':
    'Get answers, generate new ideas, and accelerate everyday work. Write a prompt to get started.',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': 'Cancel',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': 'Confirm',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button': 'There was an issue completing this action',
  'ai-mate.chat-input.actions-button.label': 'Insert elements',
  'ai-mate.chat-input.cameo-agent-talking-to': 'Talking to {agentName}',
  'ai-mate.chat-input.placeholder': 'Write a prompt, @mention someone, or use / for actions',
  'ai-mate.chat-input.send-button.label': 'Submit',
  'ai-mate.chat-input.start-recording-button.label': 'Start voice recognition',
  'ai-mate.chat-input.stop-generating-button.label': 'Stop generating',
  'ai-mate.chat-input.stop-recording-button.label': 'Stop voice recognition',
  'ai-mate.chat-input.store-user-messages.label': 'Record this message to help us improve answer quality',
  'ai-mate.chat-view.back-button.label': 'Back',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Delete',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Rename',
  'ai-mate.chat-view.chat-item.options-button-label': 'Chat options',
  'ai-mate.chat-view.close-chat-button.label': 'Close chat',
  'ai-mate.chat-view.header-title': 'Chat History',
  'ai-mate.chat-view.new-chat-button.label': 'New chat',
  'ai-mate.chat-view.no-chat': 'No results',
  'ai-mate.chat-view.search-input.placeholder': 'Search chats',
  'ai-mate.content-renderer.profile-card.view-profile-button': 'View profile',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Cancel',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'The conversation you are trying to delete does not exist.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Delete',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Delete Conversation "{name}"?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'An error occurred while deleting the conversation. Please try again.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Are you sure you want to delete this conversation? This action cannot be undone.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Cancel',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'The channel you are trying to edit does not exist.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Name',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'An error occurred while editing the conversation. Please try again.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Edit Conversation',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'The name is the same as the current name.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Save',
  'ai-mate.expander.hide-details': 'Hide details',
  'ai-mate.expander.show-details': 'Show more details',
  'ai-mate.footer.beta': 'BETA',
  'ai-mate.footer.info': 'Content quality may vary',
  'ai-mate.footer.rovo-branding-label': '{logo} Rovo',
  'ai-mate.main-chat.close-chat-button-label': 'Close',
  'ai-mate.main-chat.maximize-chat-button-label': 'Full screen',
  'ai-mate.main-chat.minimize-chat-button-label': 'Restore view',
  'ai-mate.main-chat.new-chat-button-label': 'New',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'New chat',
  'ai-mate.main-panel.deleted-agent-icon-label': 'Agent deleted',
  'ai-mate.main-panel.deleted-agent-start-new-chat': 'Start new chat',
  'ai-mate.main-panel.deleted-agent-warning': 'This agent has been deleted.',
  'ai-mate.main-panel.failed-to-load-agents': 'Failed to fetch agents',
  'ai-mate.message-renderer.error': 'Please let us know if the problem persists.',
  'ai-mate.message-renderer.error-title': 'Failed to load content',
  'chat-history.rate-limit-warning': 'Please wait {secondsRemaining, plural, one {# second} other {# seconds}}',
  'chat-history.rate-limit-warning-description': 'Messages are being sent too fast, please wait.',
  'chatHistory.storeAssistant.badResponseLabel': 'Bad response',
  'chatHistory.storeAssistant.copyResponseLabel': 'Copy',
  'chatHistory.storeAssistant.goodResponseLabel': 'Good response',
  'rovo-chat.store-assistant.insert-replace.insert-button-label': 'Insert into page',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': 'Replace selection',
};
